import { createEditorState, parseHTML } from 'components/Editor';
import { isLoading } from 'components/MediaInput';
import {
  ChallengeSubmissionForm,
  CHALLENGE_SUBMISSION_FORM_KEY,
  UPLOAD_MEDIA_FIELD,
  visualTagInputsInitialValues,
} from 'model';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { RootState } from 'redux/modules/types';
import { FormDecorator } from 'utils/forms';
import { makeFormSelectors } from 'utils/makeFormSelectors';
import { OwnProps } from './types';

const mapStateToProps = (state: RootState, { editSlug }: OwnProps) => {
  const form = CHALLENGE_SUBMISSION_FORM_KEY(editSlug);

  const { selectIsPristine, selectValues } = makeFormSelectors<
    ChallengeSubmissionForm
  >(form);
  const values = selectValues(state);

  const submissionToEdit = state.challengeResponse.bySlug[editSlug ?? ''];

  return {
    form,
    initialValues: {
      ...visualTagInputsInitialValues,
      [UPLOAD_MEDIA_FIELD]: [],
      addToMyGallery: false,
      description: createEditorState(),
      title: '',
      ...(submissionToEdit
        ? {
            [UPLOAD_MEDIA_FIELD]: submissionToEdit.mediaList
              ? [
                  submissionToEdit.mediaList.mainMedia,
                  ...submissionToEdit.mediaList.extraMedia,
                ]
              : [],
            addToMyGallery: submissionToEdit.addToMyGallery,
            description: createEditorState(
              parseHTML(submissionToEdit.description),
            ),
            graphType: submissionToEdit.graphTypes,
            industry: submissionToEdit.graphIndustry,
            title: submissionToEdit.title,
            tools: submissionToEdit.graphTools,
            topic: submissionToEdit.graphTopic,
          }
        : {}),
    },
    isPristine: selectIsPristine(state),
    loading:
      state.challengeResponse.loading ||
      isLoading(values?.[UPLOAD_MEDIA_FIELD]),
  };
};

const mapDispatchToProps = {};

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  InjectedFormProps<ChallengeSubmissionForm>;

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm<ChallengeSubmissionForm>({
    destroyOnUnmount: false,
  }),
) as FormDecorator<ChallengeSubmissionForm, OwnProps, ConnectedProps>;
